export * from './basicCard';
export {Card as AntdCard} from 'antd';